import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { authState, selectorActingAs } from 'app/auth/auth.reducer';
import { ConsignmentService } from 'app/dashboard/settings/consignments/consignment.service';
import { ConsignmentConfiguration } from 'app/dashboard/settings/consignments/consignments.interface';
import { ActingAs } from 'app/interfaces/auth.interfaces';
import { UiColors, UiThemes } from 'app/interfaces/ui.interfaces';
import { ButtonTypes } from 'app/shared/buttons/basic-button.component';
import { IconTypes } from 'app/shared/icon/icon.interfaces';
import { ModalSizes, ModalAction } from 'app/shared/modals/modal.interfaces';
import { SimpleModalComponent } from 'ngx-simple-modal';

@Component({
  selector: 'app-consignment-edit',
  templateUrl: './consignment-edit.component.html',
  styleUrls: ['./consignment-edit.component.scss']
})
export class ConsignmentEditComponent extends SimpleModalComponent<any, any> {

  public ModalSizes = ModalSizes;
  public IconTypes = IconTypes;
  public UiColors = UiColors;
  public UiThemes = UiThemes;
  public ButtonTypes = ButtonTypes;
  public actions: ModalAction[] = [
    { name: 'cancel', title: 'Cancel' },
    { name: 'confirm', title: 'Confirm', isPrimary: true },
  ];

  consignmentValue = '';
  consignmentDetails: ConsignmentConfiguration = { consignmentValues: [], useCustomConsignments: true };
  actingAs: ActingAs;

  constructor(private consignmentService: ConsignmentService, private store: Store<authState>) {
    super();
    this.store.select(selectorActingAs).subscribe((next) => {
      this.actingAs = next;
      this.consignmentService.getLiveBusinessConsignmentsConfiguration(this.actingAs.id).subscribe((result) => {
        if (!result) {
          this.consignmentDetails = { consignmentValues: [], useCustomConsignments: true};
          return;
        }
        this.consignmentDetails = result;
      });
    });
  }

  handleAction($event): void {
    if ($event === 'cancel') {
      this.close();
    }
    if ($event === 'confirm') {
      this.result = this.consignmentValue;
      this.close();
    }
  }
}
